module.exports = __webpack_public_path__ + "static/img/Gacha12.26bf2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha12.png
// module id = bZf+
// module chunks = 1